export function renderEditPageContentTemplate({
  singular,
  actionImportPath,
  kebabName,
  camelSingular
}: {
  singular: string
  actionImportPath: string
  kebabName: string
  camelSingular: string
}): string {
  return `import { notFound } from 'next/navigation'
import { get${singular}ById } from '@admin/actions/${actionImportPath}'
import { ${singular}Form } from '../../${kebabName}-form'

export async function Edit${singular}PageContent({ params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const ${camelSingular} = await get${singular}ById(id)

  if (!${camelSingular}) {
    notFound()
  }

  return <${singular}Form key={\`\${${camelSingular}.id}-\${${camelSingular}.updatedAt}\`} initialData={${camelSingular}} pageTitle="Edit ${singular}" />
}
`
}
